import { render, staticRenderFns } from "./AddVoucher.vue?vue&type=template&id=2a5656ac"
import script from "./AddVoucher.vue?vue&type=script&lang=js"
export * from "./AddVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports